export default __webpack_public_path__ + "static/media/douglas-lopes.7e61150b.mp3";